import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {navigator, router} from 'lit-element-router';
import {customElement} from 'lit/decorators.js';
import {repeat} from 'lit/directives/repeat.js';
import {msg} from '@lit/localize';
import store from '../../store';
import {fetchArtworks, selectAllArtwork, selectedArtworks} from '../../slices/artworkSlice';
import {
	selectArtworkQuery,
	selectProfileDefaultLanguage,
	selectLanguage
} from '../../selectors';
import style from '../../../../scss/artworks.scss';
import getRoutes from '../../routes';
import down from '../../icons/down';
import up from '../../icons/up';
import formPageStyle from '../../../../scss/formPage.scss';
import {exportData, exportSelected} from '../../slices/accountSlice';

@customElement('arc-artworks-selected')
export class ArtworskSelected extends connect(store)(router(navigator(LitElement))) {
	static styles = [formPageStyle, style];

	static properties = {
		artworks: {type: Array},
	};

	constructor() {
		super();
		this.artworks = [];
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = selectLanguage(state);
		this.artworkQuery = selectArtworkQuery(state);
		this.artworks = selectAllArtwork(state);
		this.totalPages = state.artwork.artworkPagination.pagesAmount;
		this.currentLanguage = selectProfileDefaultLanguage(state);
		this.exportRequested = state.account.data.exportRequested;
		this.requestUpdate();
	}

	static get routes() {
		return getRoutes();
	}

	router(route, params, query, data) {
		this.params = params;
		this.query = query;
		this.data = data;
		this.profileId = params.id;
	}

	connectedCallback() {
		super.connectedCallback();
	}
	onExportSelected(input) {
		console.log('export selected', selectedArtworks(this.state));
		store.dispatch(exportSelected({artworkIds: selectedArtworks(this.state)}));
	}

	getOrderQuery(orderBy) {
		const orderByDirection = this.query?.orderByDirection || 'asc';
		const newQuery = {
			...this.query,
			orderBy: orderBy,
			orderByDirection: orderByDirection === 'desc' ? 'asc' : 'desc',
		};
		return newQuery;
	}

	getOrderDirectionIcon(orderBy) {
		if (this.query && this.query.orderBy === orderBy) {
			return this.query.orderByDirection === 'asc' ? down : up;
		} else {
			return '';
		}
	}

	render() {
		return html`
			<div class="formPage artworks bin">
				<arc-toolbar class="toolbar">
					<div slot="left">
						<arc-breadcrumbs>
							<arc-routerlink route="artworks">${msg('Artworks')}</arc-routerlink>
							<span>${msg('Selected Artworks')}</span>
						</arc-breadcrumbs>
						<arc-content-language-switch></arc-content-language-switch>
					</div>
					<div slot="right">
						<arc-button
							@click=${this.onExportSelected}
							title="${msg('Export Selected')}"
							type="primary"
							?disabled=${this.exportRequested}
							.additionalInfo="${false}"
						>
						</arc-button>
					</div>
				</arc-toolbar>

				<arc-artwork-list
					class="artworkList"
					.selected="${true}"
					.selectMultiple=${true}
					.noFilters="${true}"
				></arc-artwork-list>
			</div>
		`;
	}
}
